const READ_FAILURE_STORAGE_KEY = 'sacon.readFailures';
const MAX_READ_FAILURES = 30;

type ReadFailure = {
  path: string;
  requestId?: string;
  status: number;
  durationMs: number;
  reason: 'HTTP_ERROR' | 'NETWORK_ERROR' | 'TIMEOUT' | 'INVALID_RESPONSE';
};

/** 브라우저 실패는 서버에 도달하지 않을 수 있어 새로고침 뒤에도 탭별 최근 이력을 남깁니다. */
export function recordReadFailure(failure: ReadFailure): void {
  if (typeof window === 'undefined') return;
  const record = {
    timestamp: new Date().toISOString(),
    // 쿼리·fragment·외부 origin과 오류 원문에는 인증 정보가 포함될 수 있어 기록하지 않습니다.
    path: failure.path.startsWith('/') && !failure.path.startsWith('//') ? failure.path.split(/[?#]/, 1)[0].slice(0, 300) : '(invalid-path)',
    request_id: failure.requestId && /^[a-zA-Z0-9_-]{1,128}$/.test(failure.requestId) ? failure.requestId : undefined,
    status: failure.status,
    duration_ms: Math.max(0, Math.round(failure.durationMs)),
    reason: failure.reason,
    online: navigator.onLine,
    visibility: document.visibilityState,
  };
  console.warn('[read-recovery] 데이터 조회 실패', { ...record, log_event: 'browser.read.failed', protocol: 'http', service: 'api', stage: 'ERROR' });
  try {
    const raw = window.sessionStorage.getItem(READ_FAILURE_STORAGE_KEY) ?? '[]';
    const stored: unknown = raw.length <= 32_000 ? JSON.parse(raw) : [];
    // 기존 저장소가 손상되어도 현재 진단과 크기 한도를 유지하고 알 수 없는 필드는 복사하지 않습니다.
    const previous = Array.isArray(stored)
      ? stored
          .filter(item => item && typeof item === 'object' && typeof item.timestamp === 'string')
          .slice(-(MAX_READ_FAILURES - 1))
          .map(({ timestamp, path, request_id, status, duration_ms, reason, online, visibility }) => ({
            timestamp,
            path,
            request_id,
            status,
            duration_ms,
            reason,
            online,
            visibility,
          }))
      : [];
    window.sessionStorage.setItem(READ_FAILURE_STORAGE_KEY, JSON.stringify([...previous, record]));
  } catch {
    // 저장 공간 제한·비공개 모드의 저장 거부가 원래 조회 오류 처리와 복구를 방해하지 않게 합니다.
  }
}
